<template>
  <div class="create-user">
    <div class="create-user-form">
      <div class="create-user-form-title">账号开通管理页</div>
      <a-form
        :form="form"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="createUser"
      >
        <a-form-item label="商户名称">
          <a-input
            v-decorator="['fullName', { rules: [{ required: true, message: '请输入商户名称!' }] }]"
            placeholder="请输入商户名称"
            style="width: 450px"
          />
        </a-form-item>
        <a-form-item label="商户简称">
          <a-input
            v-decorator="['shortName']"
            placeholder="请输入商户简称"
            style="width: 450px"
          />
        </a-form-item>
        <a-form-item label="米雅商户号">
          <a-input
            v-decorator="['tenantCode', { rules: [{ required: true, message: '请输入米雅商户号!' }] }]"
            placeholder="请输入米雅商户号"
            style="width: 450px"
          />
        </a-form-item>
        <a-form-item label="登录账号">
          <a-input
            v-decorator="['userName', { rules: [{ required: true, message: '请输入登录账号!' }] }]"
            placeholder="请输入登录账号"
            style="width: 450px"
          />
        </a-form-item>
        <a-form-item label="内部校验码">
          <a-input
            v-decorator="['backDoorKey', { rules: [{ required: true, message: '请输入内部校验码!' }] }]"
            placeholder="请输入内部校验码"
            style="width: 450px"
          />
        </a-form-item>
        <a-form-item label="合同过期时间">
          <a-date-picker
            v-decorator="['expireTime', { rules: [{ required: true, message: '请选择合同过期时间!' }] }]"
            placeholder="请选择合同过期时间"
            style="width: 450px"
            value-format="YYYY-MM-DD"
            :popup-style="{backgroundColor:'#fff'}"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button
            type="primary"
            html-type="submit"
          >
            创建
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { createUserApi } from '@/apis/create-user';

export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  methods: {
    createUser(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err);
          return;
        }
        createUserApi(values).then(() => {
          this.$message.success('创建成功');
          this.form.resetFields();
        }).catch((err) => {
          this.$message.error(err.message);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.create-user {
  width: 100%;
  height: 100vh;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .create-user-form-title {
    font-size: 32px;
    font-weight: bold;
    margin: 20px 0;
    text-align: center;
  }
  .create-user-form {
    width: 700px;
    height: 500px;
    padding: 30px;
    background: #fff;
  }
}
</style>
